import PropTypes from 'prop-types';
import product from './product';

export default PropTypes.arrayOf(product);
